import { forEach, set, get } from 'lodash'
import extractDataValue from './extract-data-value'
import postcss from 'postcss'
import shorthandExpand from './postcss/postcss-shorthand-expand'
import CodeManager from 'Functions/code-manager'

// Note: Cachig library memoize.

const cachedResultForExpandShorthandFn = {}

// https://jsbin.com/wefatehuro/edit?html,js,console
/* 
import getHash from 'Functions/get-hash'
function expandShorthandCssProperties( code = '' ) {
	// Stupid simple function caching.
	// Return cached value if the same code already processed.
	const codeHash = getHash( code )
	if ( codeHash in cachedResultForExpandShorthandFn ) {
		return cachedResultForExpandShorthandFn[ codeHash ]
	}

	// @todo: you can make this code faster by replaceing process to parse
	code = postcss( [ shorthandExpand() ] ).process( code ).css

	// Cache result.
	cachedResultForExpandShorthandFn[ codeHash ] = code

	return code
}
 */
// ============================================================

window.cachedAllValuesBySelector = {}

// Function used as custom PostCSS filter to extract all CSS values by selector.
function cacheAllCssValuesBySelector( { cssSelector } ) {
	// Documentation: http://api.postcss.org/
	return ( root, result ) => {
		// https://regex101.com/r/vRUjj2/11
		const selectorRegex = new RegExp( "(?:^\\s*|,\\s*)" + window.stlst_legacy.prepare_regex_string( cssSelector ) + "(?:\\s*,|\\s*$)", "m" )
		// ↑ don't use "g" (global) key in the regex above!
		//				↓ Filter	 ↓ Callback

		root.walkRules( selectorRegex, ( rule, index ) => {
			rule.walkDecls( decl => {
				let currentSize = 'desktop'
				// Check if we have any mediaQueries as grand-parent rule?
				if ( "atrule" === decl.parent.parent.type &&
					"media" === decl.parent.parent.name ) {
					currentSize = decl.parent.parent.params
				}
				// Save value into the resulting cache object.
				// cachedAllValuesBySelector.responsiveSize.cssSelector.cssProperty = cssValue.
				set( window.cachedAllValuesBySelector, '["' + currentSize + '"].' + decl.prop, decl.value )
			} )
		} )
	}
}

// ============================================================

// Cache storage.
window.Stylist.cachedCssValues = {}

/**
 * Get inserted (our custom) style by selector and rule.
 */

export function getCssValue( {
	cssSelector = window.Stylist.cssSelectorCustom,
	cssProperty,
	responsiveSize = window.stlst_legacy.get_media_condition() } ) {
	const cachedValue = get( window.Stylist.cachedCssValues, '["' + cssSelector + '"]' + '["' + responsiveSize + '"]' + '["' + cssProperty + '"]', false )
	return cachedValue
}

export function cacheCssValuesForSelector( { cssSelector = window.Stylist.cssSelectorCustom, cssCode = CodeManager.getCode() } ) {
	if ( ! cssSelector ) {
		return
	}

	return new Promise( ( resolve, reject ) => {
		/**
		 * POSTCSS PLUGIN: shorthandExpand
		 * Replace all compounded rules like margin: XX XX XX XX
		 * into full-lenght properties like maring-right, margin-top, etc.
		 *
		 * POSTCSS PLUGIN: cacheAllCssValuesBySelector
		 * Compose an object (cachedAllValuesBySelector) with all properties
		 * for the proided selector.
		 */
		postcss( [
			shorthandExpand(),
			cacheAllCssValuesBySelector( {
				cssSelector: cssSelector
			} )
		] ).process( cssCode ).then( result => {
			// By this point cachedAllValuesBySelector filled with data,
			// so we can set it as a value for getCssValueCachedResults[cacheId]:
			set( window.Stylist.cachedCssValues, '["' + cssSelector + '"]', window.cachedAllValuesBySelector )
			window.Stylist.setCssCacheReady()
			window.cachedAllValuesBySelector = {}
			resolve( true )
		} )
	} )
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/get-css-value.js